// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const PlayPlaying = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			fill="#FFF"
			fillRule="evenodd"
			d="M15 55h14a3 3 0 0 1 3 3v19a3 3 0 0 1-3 3H15a3 3 0 0 1-3-3V58a3 3 0 0 1 3-3Zm52-17h14a3 3 0 0 1 3 3v36a3 3 0 0 1-3 3H67a3 3 0 0 1-3-3V41a3 3 0 0 1 3-3ZM41 17h14a3 3 0 0 1 3 3v57a3 3 0 0 1-3 3H41a3 3 0 0 1-3-3V20a3 3 0 0 1 3-3Z"
		/>
	</svg>
);
export default PlayPlaying;
